import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/StyledComponents';

export const ExtractedFieldHighlightsRoot = styled('div', { label: 'ExtractedFieldHighlightsRoot' })(() => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  top: 0,
  zIndex: PAGE_Z_INDEX.EXTRACTED_FIELD_HIGHLIGHTS,
  userSelect: 'none',
}));

export const ExtractedFieldHighlight = styled('div', { label: 'ExtractedFieldHighlight' })(() => ({
  position: 'absolute',
  border: '1px solid rgb(221, 129, 0)',
  boxSizing: 'content-box',
  pointerEvents: 'none',
  userSelect: 'none',
  opacity: 1,
  background: 'rgba(225, 225, 0, 0.15)',
}));
